const plugin = require('tailwindcss/plugin');
const exists = Boolean;

const getKey = (...fragments) => fragments.filter(exists).join('-');

const getThemeValue = (theme) => (prop, value) => {
  const themeValue = theme(`${prop}.${value}`);

  return themeValue ?? value;
};

const getVariant = (theme, props) => {
  const { font, size, weight, style, tracking, leading, transform, align, color, stretch } = { ...props };
  const getValue = getThemeValue(theme);

  /** @type {import('react').CSSProperties}  */

  const styles = {
    fontFamily: getValue('fontFamily', font),
    fontSize: getValue('fontSize', size),
    fontWeight: getValue('fontWeight', weight),
    fontStyle: getValue('fontStyle', style),
    fontStretch: getValue('fontStretch', stretch),
    letterSpacing: getValue('letterSpacing', tracking),
    lineHeight: getValue('lineHeight', leading),
    textTransform: getValue('textTransform', transform),
    textAlign: getValue('textAlign', align),
    color: getValue('colors', color),
  };

  return styles;
};

const getVariantsGroup = (theme, group, variants) => {
  return Object.entries(variants).reduce((result, [variant, values]) => {
    const modifier = variant === 'DEFAULT' ? null : variant;
    const key = getKey('.text', group, modifier);
    const value = getVariant(theme, values);

    return { ...result, [key]: value };
  }, {});
};

const getUtilities = (theme, config, { screen } = {}) => {
  return Object.entries(config).reduce((result, [group, variants]) => {
    const key = getKey(group, screen);
    const values = getVariantsGroup(theme, key, variants);

    return { ...result, ...values };
  }, {});
};

const typographyPlugin = (config, { screen } = {}) => {
  return plugin(({ addUtilities, theme }) => {
    const typographyStyles = getUtilities(theme, config, { screen });

    return addUtilities(typographyStyles);
  });
};

module.exports = Object.assign(typographyPlugin, { getUtilities });
